// Automatically use live URL in production or localhost during development
const BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://api.protechtion.co.zw'
  : 'http://localhost:5000';

export const apiFetch = async (url, method = 'GET', body = null) => {
  const token = localStorage.getItem('token');

  const res = await fetch(`${BASE_URL}${url}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    ...(body && { body: JSON.stringify(body) }),
  });

  const contentType = res.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    const text = await res.text();
    throw new Error(`Unexpected response: ${text}`);
  }

  return await res.json();
};
